<div class="{{theme}}-theme audio-parent">
    <div class="position-relative border-lg-bottom" *ngIf="topic">
        <div class="topic-wrapper">
            <img src="{{topic.featureImageUrl}}" class="topic-featured-img d-lg-none" />
            <div class="df-topic">
                <div class="border-bottom">
                    <div class="container-fluid">
                        <div class="row py-4">

                            <div class="col-12 pt-3">
                                <div class="subtitle">Principle {{topic.principleNumber}}:</div>
                                <h2>{{topic.title}}</h2>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="container-fluid py-4">
                    <div class="row pt-4 pb-3">
                        <div class="col-12 subtitle" [innerHtml]="topic.subtitle"></div>
                    </div>
                    <audio-transcript [source]="topic.audioUrl" [transcript]="topic.transcript"></audio-transcript>
                </div>
            </div>

            <img src="{{topic.featureImageUrl}}" class="border-lg-bottom-0 border-lg-left topic-featured-img d-none d-lg-block" />
        </div>
    </div>
    <div class="border-bottom" *ngIf="pebcontent">
        <div class="container-fluid py-5">
            <div class="row pb-3">
                <div class="offset-2 offset-lg-1 col text-xlarge" [innerHTML]="pebcontent.title.text"></div>
            </div>
            <div class="row">
                <div class="col-10 offset-2 col-lg-11 offset-lg-1 pb-4 pb-lg-0">
                    <div class="row peb-images-text-container">
                        <div *ngFor="let item of pebcontent.imagesWithText"
                            class="col-12 col-md-8 col-lg-4 pb-lg-4 py-3 peb-image-text">
                            <div class="d-flex flex-column align-items-center justify-content-center">
                                <img src="{{item.imageUrl}}" class="img-fluid pb-4" />
                                <div class="text-large" [innerHtml]="item.text"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="reflection-journal-theme border-bottom">
    <div class="container-fluid">
        <div class="row py-4">
            <div class="col-12">
                <h3 class="font-italic reflection-journal">Reflection Journal</h3>
            </div>
        </div>
    </div>
    <div *ngIf="topicAnswers">
        <div class="border-top" *ngFor="let question of nonAssessmentAnswers; let i=index">
            <div class="container-fluid py-4">
                <div class="row">
                    <div class="col-12 col-lg-10 subtitle">{{question.questionText}}</div>
                </div>
                <div class="row pt-2">
                    <div class="col-12 col-lg-9">
                        <elemental-input [question]="question"
                            (answerChanged)="answerChanged($event, question.answerId, i)"></elemental-input>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="self-assessment-theme border-bottom">
    <div class="container-fluid">
        <div class="row py-4">
            <div class="col-12">
                <h3 class="font-italic self-assessment d-flex">Principles of Equitable Behavior self-assessment</h3>
            </div>
        </div>
    </div>
    <div class="w-100 border-bottom"></div>
    <div class="container-fluid" *ngIf="topic">
        <ng-container *ngFor="let assessment of topic.assessments; let i=index">
            <div class="row pt-3">
                <div class="col-12 col-lg-10 subtitle">{{assessment.title}}</div>
                <div class="col-12 py-4">
                    <div class="d-flex flex-column flex-lg-row justify-content-lg-between">
                        <div [ngClass]="{ 'peb-assessment-option':true, 'p-2': true, 'p-lg-4':true, 'active':seededTitleActive }"
                            (click)="assessmentAnswer(assessment.seededTitle, assessment.id)">
                            <img src="https://equityisdynamic-static.s3.amazonaws.com/peb/section1/Rectangle+96.png"
                                alt="seeded" />
                            <div class="pt-lg-3">
                                <div class="subtitle pb-2">{{assessment.seededTitle}}</div>
                                <div>{{assessment.seededText}}</div>
                            </div>
                        </div>
                        <div [ngClass]="{ 'peb-assessment-option':true, 'p-2': true, 'p-lg-4':true, 'active':sproutingTitleActive }"
                            (click)="assessmentAnswer(assessment.sproutingTitle, assessment.id)">
                            <img src="https://equityisdynamic-static.s3.amazonaws.com/peb/section1/Rectangle+96-1.png"
                                alt="sprouting" />
                            <div class="pt-lg-3">
                                <div class="subtitle pb-2">{{assessment.sproutingTitle}}</div>
                                <div>{{assessment.sproutingText}}</div>
                            </div>
                        </div>
                        <div [ngClass]="{ 'peb-assessment-option':true, 'p-2': true, 'p-lg-4':true, 'active':bloomingTitleActive }"
                            (click)="assessmentAnswer(assessment.bloomingTitle, assessment.id)">
                            <img src="https://equityisdynamic-static.s3.amazonaws.com/peb/section1/Rectangle+96-2.png"
                                alt="blooming" />
                            <div class="pt-lg-3">
                                <div class="subtitle pb-2">{{assessment.bloomingTitle}}</div>
                                <div>{{assessment.bloomingText}}</div>
                            </div>
                        </div>
                        <div [ngClass]="{ 'peb-assessment-option':true, 'p-2': true, 'p-lg-4':true, 'active':fullBloomTitleActive }"
                            (click)="assessmentAnswer(assessment.fullBloomTitle, assessment.id)">
                            <img src="https://equityisdynamic-static.s3.amazonaws.com/peb/section1/Rectangle+96-3.png"
                                alt="full bloom" />
                            <div class="pt-lg-3">
                                <div class="subtitle pb-2">{{assessment.fullBloomTitle}}</div>
                                <div>{{assessment.fullBloomText}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>

    </div>
</div>